import * as React from "react";
import { useTranslation } from 'react-i18next';

export const useTableColumns = () => {
    const { t } = useTranslation();
    
    return [    
        {
            label: t("common.name"),
            field: "key",
            sort: "desc",
            width: 150,
            type: "enum",
            enumType: "globalConfigKey"
        },
        {
            label: t("common.value"),
            field: "value",
            sort: "desc",
            width: 150,
        }
    ];
};

export default useTableColumns;